"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = void 0;
/**
 * Collects errors from data paths
 */
class Errors {
    constructor() {
        this.errors = [];
    }
    add(path, error, ...params) {
        this.errors.push({ path, error, params });
        return false;
    }
    get(path, exact = false) {
        return exact ? this.errors.filter(e => e.path.equals(path))
            : this.errors.filter(e => e.path.startsWith(path));
    }
    getAll() {
        return this.errors;
    }
    clear() {
        this.errors = [];
    }
    count() {
        return this.errors.length;
    }
    *[Symbol.iterator]() {
        for (const e of this.errors) {
            yield e;
        }
    }
}
exports.Errors = Errors;
